import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(public router: Router) { }
  fecha;
  nombre;
  mes(m){
    var mes =[ "","Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    return mes[m];
  }
  ngOnInit() {
    const day =   localStorage.getItem("dia_hoy");    
    const month =  localStorage.getItem("mes_hoy");
    const year =   localStorage.getItem("anio_hoy");
    this.fecha=day+" de "+this.mes(Number(month))+" de  "+year;
    this.nombre=localStorage.getItem("nombre");
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
}
